import { render, staticRenderFns } from "./InvoiceDetailsPage.vue?vue&type=template&id=219b5b14&scoped=true"
import script from "./InvoiceDetailsPage.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDetailsPage.vue?vue&type=style&index=0&id=219b5b14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219b5b14",
  null
  
)

export default component.exports